<template>
  <div
    class="modal_wrapper active"
    @click="closeModal()"
  >
    <div
      class="modal_window white_box create_report_modal"
      @click.stop=""
    >
      <div class="modal_header">
        <h3 class="heading">
          Add New Widget
        </h3>
        <button
          class="close_modal close_btn"
          @click="closeModal()"
        >
          <svg
            fill="none"
            height="32"
            viewBox="0 0 32 32"
            width="32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 7L7 25"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M25 25L7 7"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </button>
      </div>
      <div class="section_modal_content white_box flex edit_section_modal mb_16">
        <div class="content">
          <accordion-section
            :items="items"
            :selected-index="selectedOptionIndex"
            @selected="option => {
              if(option.create) {
                $emit('create', option)
              } else {
                $emit('selected', option)
              }
            }"
          />
        </div>
      </div>
      <div class="section_modal_footer">
        <button
          class="btn btn_md secondary_btn"
          @click="closeModal()"
        >
          <span>Close</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {mapActions, mapState} from 'vuex'
import AccordionSection from '../../../reports/components/builder/items/AccordionSection'

export default {
  components: {
    AccordionSection
  },
  emits: [
    'create',
    'selected',
  ],
  data() {
    return {}
  },
  computed: {
    ...mapState('dashboard', ['layout', 'customWidgets', 'selectedOptionIndex']),
    ...mapState('user', ['user']),
    items() {
      let items = []
      let actionWidgets = {
        name: 'Actions',
        options: [
          {
            name: `Action Progress${_.filter(this.addedWidgets, (w) => {
              return w.includes('action-progress')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `action-progress-${Date.now()}`, "component": "ActionProgress"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('action-progress')
            }).length > 0,
          },
          {
            name: `Priority SEO Actions${_.filter(this.addedWidgets, (w) => {
              return w.includes('priority-actions')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `priority-actions-${Date.now()}`, "component": "PriorityActions"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('priority-actions')
            }).length > 0,
          },
          {
            name: `Completed SEO Actions${_.filter(this.addedWidgets, (w) => {
              return w.includes('completed-actions')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `completed-actions-${Date.now()}`, "component": "CompletedActions"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('completed-actions')
            }).length > 0,
          }
        ]
      };
      let backlinksWidgets = {
        name: 'Backlinks',
        options: [
          {
            name: `Domain Authority${_.filter(this.addedWidgets, (w) => {
              return w.includes('domain-authority')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `domain-authority-${Date.now()}`, "component": "DomainAuthority"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('domain-authority')
            }).length > 0,
          },
          {
            name: `New Backlinks${_.filter(this.addedWidgets, (w) => {
              return w.includes('new-backlinks')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `new-backlinks-${Date.now()}`, "component": "NewBacklinks"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('new-backlinks')
            }).length > 0,
          },
          {
            name: `Top Backlinks${_.filter(this.addedWidgets, (w) => {
              return w.includes('top-backlinks')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `top-backlinks-${Date.now()}`, "component": "TopBacklinks"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('top-backlinks')
            }).length > 0,
          }
        ]
      };
      let keywordWidgets = {
        name: 'Keywords',
        options: [
          {
            name: `Average Ranking${_.filter(this.addedWidgets, (w) => {
              return w.includes('average-keyword-ranking')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `average-keyword-ranking-${Date.now()}`, "component": "AverageRanking"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('average-keyword-ranking')
            }).length > 0,
          },
          {
            name: `Keywords Rankings${_.filter(this.addedWidgets, (w) => {
              return w.includes('keyword-rankings')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `keyword-rankings-${Date.now()}`, "component": "KeywordRankings"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('keyword-rankings')
            }).length > 0,
          }
        ]
      };
      let gscWidgets = {
        name: 'Search Console',
        options: [
          {
            name: `Clicks and Impressions${_.filter(this.addedWidgets, (w) => {
              return w.includes('clicks-and-impressions')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `clicks-and-impressions-${Date.now()}`, "component": "ClicksAndImpressions"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('clicks-and-impressions')
            }).length > 0,
          }
        ]
      };
      let trafficWidgets = {
        name: 'Traffic',
        options: [
          {
            name: `Traffic Stats${_.filter(this.addedWidgets, (w) => {
              return w.includes('traffic-stats')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `traffic-stats-${Date.now()}`, "component": "TrafficStats"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('traffic-stats')
            }).length > 0,
          },
          {
            name: `Top Cities${_.filter(this.addedWidgets, (w) => {
              return w.includes('top-cities')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `top-cities-${Date.now()}`, "component": "TopCities"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('top-cities')
            }).length > 0,
          },
          {
            name: `Top Countries${_.filter(this.addedWidgets, (w) => {
              return w.includes('top-countries')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `top-countries-${Date.now()}`, "component": "TopCountries"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('top-countries')
            }).length > 0,
          },
          {
            name: `Top Devices${_.filter(this.addedWidgets, (w) => {
              return w.includes('top-devices')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `top-devices-${Date.now()}`, "component": "TopDevices"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('top-devices')
            }).length > 0,
          },
          {
            name: `Top Referrers${_.filter(this.addedWidgets, (w) => {
              return w.includes('top-referrers')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `top-referrers-${Date.now()}`, "component": "TopReferrers"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('top-referrers')
            }).length > 0,
          },
          {
            name: `Top Traffic Sources${_.filter(this.addedWidgets, (w) => {
              return w.includes('top-traffic-source')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `top-traffic-source-${Date.now()}`, "component": "TopTrafficSources"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('top-traffic-source')
            }).length > 0,
          },
          {
            name: `Website Visits${_.filter(this.addedWidgets, (w) => {
              return w.includes('website-visits')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `website-visits-${Date.now()}`, "component": "WebsiteVisits"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('website-visits')
            }).length > 0,
          }
        ]
      };
      let competitionWidgets = {
        name: 'Competition',
        options: [
          {
            name: `Competition Keywords${this.getWidgetCount('competition-keywords') > 0 ? ` - ${this.getWidgetCount('competition-keywords')} Added` : ''}`,
            widget: {"w": 1, "id": `competition-keywords-${Date.now()}`, "component": "CompetitionKeywords"},
            next: 'chooseCompetitors'
          },
          {
            name: `Competition Backlinks${this.getWidgetCount('competition-backlinks') > 0 ? ` - ${this.getWidgetCount('competition-backlinks')} Added` : ''}`,
            widget: {"w": 1, "id": `competition-backlinks-${Date.now()}`, "component": "CompetitionBacklinks"},
            next: 'chooseCompetitors'
          },
        ]
      };
      let localWidgets = {
        name: 'Local',
        options: [
          {
            name: 'Performance',
            children: [
              {
                name: `Map Views${this.getWidgetCount('map-views') > 0 ? ` - ${this.getWidgetCount('map-views')} Added` : ''}`,
                widget: {"w": 1, "id": `map-views-${Date.now()}`, "component": "MapViews"},
                next: 'chooseLocation'
              },
              {
                name: `Search Views${this.getWidgetCount('search-views') > 0 ? ` - ${this.getWidgetCount('search-views')} Added` : ''}`,
                widget: {"w": 1, "id": `search-views-${Date.now()}`, "component": "SearchViews"},
                next: 'chooseLocation'
              },
              {
                name: `Website Clicks${this.getWidgetCount('website-clicks') > 0 ? ` - ${this.getWidgetCount('website-clicks')} Added` : ''}`,
                widget: {"w": 1, "id": `website-clicks-${Date.now()}`, "component": "WebsiteClicks"},
                next: 'chooseLocation'
              },
              {
                name: `Phone Calls${this.getWidgetCount('phone-calls') > 0 ? ` - ${this.getWidgetCount('phone-calls')} Added` : ''}`,
                widget: {"w": 1, "id": `phone-calls-${Date.now()}`, "component": "PhoneCalls"},
                next: 'chooseLocation'
              },
              {
                name: `Direction Requests${this.getWidgetCount('direction-requests') > 0 ? ` - ${this.getWidgetCount('direction-requests')} Added` : ''}`,
                widget: {"w": 1, "id": `direction-requests-${Date.now()}`, "component": "DirectionRequests"},
                next: 'chooseLocation'
              },
            ]
          },
          {
            name: `Correct Citations${this.getWidgetCount('correct-citations') > 0 ? ` - ${this.getWidgetCount('correct-citations')} Added` : ''}`,
            widget: {"w": 1, "id": `correct-citations-${Date.now()}`, "component": "CorrectCitations"},
            next: 'chooseLocation'
          },
          {
            name: `Incorrect Citations${this.getWidgetCount('incorrect-citations') > 0 ? ` - ${this.getWidgetCount('incorrect-citations')} Added` : ''}`,
            widget: {"w": 1, "id": `incorrect-citations-${Date.now()}`, "component": "IncorrectCitations"},
            next: 'chooseLocation'
          },
          {
            name: `Missing Citations${this.getWidgetCount('missing-citations') > 0 ? ` - ${this.getWidgetCount('missing-citations')} Added` : ''}`,
            widget: {"w": 1, "id": `missing-citations-${Date.now()}`, "component": "MissingCitations"},
            next: 'chooseLocation'
          },
          {
            name: `New Reviews${this.getWidgetCount('all-new-reviews') > 0 ? ` - ${this.getWidgetCount('all-new-reviews')} Added` : ''}`,
            widget: {"w": 1, "id": `all-new-reviews-${Date.now()}`, "component": "AllNewReviews"},
            next: 'chooseLocation'
          },
          {
            name: `New Reviews (3-5 Star)${this.getWidgetCount('new-reviews-3-plus') > 0 ? ` - ${this.getWidgetCount('new-reviews-3-plus')} Added` : ''}`,
            widget: {"w": 1, "id": `new-reviews-3-plus-${Date.now()}`, "component": "NewReviews3Plus"},
            next: 'chooseLocation'
          },
          {
            name: `Scheduled Posts${this.getWidgetCount('local-post-cta') > 0 ? ` - ${this.getWidgetCount('local-post-cta')} Added` : ''}`,
            widget: {"w": 1, "id": `scheduled-posts-${Date.now()}`, "component": "ScheduledPosts"},
            next: 'chooseLocation'
          },
          {
            name: `Local Keyword Rankings${_.filter(this.addedWidgets, (w) => {
              return w.includes('local-keyword-rankings')
            }).length > 0 ? ' - Added' : ''}`,
            widget: {"w": 1, "id": `local-keyword-rankings-${Date.now()}`, "component": "LocalKeywordRankings"},
            disabled: _.filter(this.addedWidgets, (w) => {
              return w.includes('local-keyword-rankings')
            }).length > 0,
          },
          {
            name: `Average Local Ranking${this.getWidgetCount('average-local-ranking') > 0 ? ` - ${this.getWidgetCount('average-local-ranking')} Added` : ''}`,
            widget: {"w": 1, "id": `average-local-ranking-${Date.now()}`, "component": "AverageLocalRanking"},
            next: 'chooseLocalAverageType'
          }
        ]
      };

      if (this.user.permissions.action_permission != 'HIDDEN') items.push(actionWidgets);
      if (this.user.permissions.backlinks_permission != 'HIDDEN') items.push(backlinksWidgets);
      if (this.user.permissions.keywords_permission != 'HIDDEN') items.push(keywordWidgets);
      if (this.user.permissions.reporting_permission != 'HIDDEN') items.push(gscWidgets, trafficWidgets);
      if (this.user.permissions.competition_permission != 'HIDDEN') items.push(competitionWidgets);
      if (this.user.permissions.local_permission != 'HIDDEN') items.push(localWidgets);

      if (this.customWidgets.length > 0) {
        items.push(
            {
              name: 'My Custom Widgets',
              options: [
                ...this.customOptions,
              ]
            },
        );
      }

      return items;
    },
    customOptions() {
      let options = [];
      _.each(this.customWidgets, (widget) => {
        options.push({
          name: `${widget.heading}${_.filter(this.addedWidgets, (w) => {
            return w.includes(`${widget.heading}-${widget.id}`)
          }).length > 0 ? ' - Added' : ''}`,
          widget: {
            "w": 1,
            "id": `${widget.heading}-${widget.id}`,
            "component": "CustomWidget",
            "custom_widget_id": widget.id,
          },
          disabled: _.filter(this.addedWidgets, (w) => {
            return w.includes(`${widget.heading}-${widget.id}`)
          }).length > 0,
        })
      });
      return options;
    },
    addedWidgets() {
      let ids = [];
      _.each(this.layout, widget => {
        ids.push(widget.id);
      });

      return ids;
    }
  },
  methods: {
    ...mapActions({
      closeModal: 'dashboard/closeAddWidgetModal',
    }),
    getWidgetCount(prefix) {
      return _.filter(this.addedWidgets, (w) => {
        return w.includes(prefix)
      }).length
    },
  }
}
</script>

<style scoped>
.content {
  width: 100%;
}
</style>
<style scoped>
.section_modal_content {
  max-height: 70vh;
  overflow: auto;
}

.section_modal_footer {
  display: flex;
  justify-content: flex-end;
}

.section_modal_footer button {
  height: 43px;
  padding: 0 1.5rem;
}
</style>
